<template>
  <v-dialog max-width="1000px"
            :value="value"
            @input="toggleModal"
            persistent
            scrollable>
    <v-card>
      <v-toolbar dark color="abadPrimary" flat>
        <v-toolbar-title>{{ formatTitle }}</v-toolbar-title>

        <v-spacer/>

        <v-btn icon
               @click="toggleModal()">
          <v-icon>
            clear
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form :value="valid"
                ref="ownerAdviserForm"
                lazy-validation>
          <v-row>
            <v-col cols="12" class="text-h6 abadPrimary--text">
              Datos Principales
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-text-field label="Nombre completo"
                            :rules="[rules.required]"
                            v-model="perfil.nombres">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-text-field label="Fecha de nacimiento"
                            v-model="perfil.fechaNacimiento">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-text-field label="Cédula"
                            :rules="[rules.required]"
                            v-model.number="perfil.cedula">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-text-field label="Email"
                            v-model="perfil.email">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-text-field label="Celular"
                            :rules="[rules.required]"
                            v-model.number="perfil.celular">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-text-field label="Teléfono fijo"
                            v-model.number="perfil.fijo">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-select :items="constants.gender"
                        label="Género"
                        v-model="perfil.genero">
              </v-select>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-text-field label="País"
                            v-model="perfil.pais">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4" lg="3">
              <v-text-field label="Ciudad"
                            v-model="perfil.ciudad">
              </v-text-field>
            </v-col>

            <v-col cols="12" class="text-h6 abadPrimary--text">
              Contacto 2
            </v-col>

            <v-col cols="12">
              <v-text-field label="Nombre completo"
                            v-model="perfil.nombres2">
              </v-text-field>
            </v-col>

            <v-col cols="12" lg="6">
              <v-text-field label="Email"></v-text-field>
            </v-col>

            <v-col cols="12" lg="6">
              <v-text-field label="Celular"
                            v-model="perfil.celular2">
              </v-text-field>
            </v-col>

            <v-col cols="12" lg="6">
              <v-text-field label="Fijo"
                            v-model="perfil.fijo2">
              </v-text-field>
            </v-col>

            <v-col cols="12" lg="6">
              <v-text-field label="País"></v-text-field>
            </v-col>

            <v-col cols="12" lg="6">
              <v-text-field label="Ciudad"></v-text-field>
            </v-col>

            <v-col cols="12" class="text-h6 abadPrimary--text">
              Otros datos
            </v-col>

            <v-col cols="12">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-textarea label="Observaciones"
                              v-on="on"
                              v-model="perfil.comentarios">
                  </v-textarea>
                </template>

                <span>Esta información se muestra solo para los asesores que inicien sesión</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>

        <v-btn color="red"
               text
               @click="toggleModal">
          Cancelar
        </v-btn>

        <v-btn color="abadPrimary"
               dark
               @click="submit()"
               :loading="loading">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constants from '@/pages/RealEstate/libs/constants'
import notifications from '@/libs/notifications'
import realEstateService from '@/services/realEstateService.js'
import rules from '@/libs/rules'
export default {
  props: ['selected', 'type', 'value'],
  computed: {
    formatTitle () {
      let title = ''
      title += this.selected ? 'Editar ' : 'Crear '
      title += this.type === 'owner' ? 'Propietario' : 'Asesor'
      return title
    }
  },
  data () {
    return {
      constants,
      loading: false,
      perfil: {
        email: '',
        cedula: '',
        nombres: '',
        fijo: '',
        celular: '',
        fechaNacimiento: '',
        nombres2: '',
        fijo2: '',
        celular2: '',
        comentarios: ''
      },
      rules,
      valid: true
    }
  },
  methods: {
    submit () {
      if (!this.$refs.ownerAdviserForm.validate()) return

      this.loading = true

      if (this.type === 'owner') {
        this.createEditOwner()
      } else {
        this.createEditAdviser()
      }
    },
    async createEditAdviser () {
      if (this.selected) {
        await realEstateService.editAdviser({ ...this.perfil, id: this.selected.id })
      } else {
        await realEstateService.createAdviser(this.perfil)
      }

      this.loading = false
      notifications.success(`${this.type === 'owner' ? 'Propietario' : 'Asesor'} ${this.selected ? 'editado' : 'creado'} correctamente`)
      await this.$store.dispatch('getRealEstateAdvisers')
      this.toggleModal()
    },
    async createEditOwner () {
      if (this.selected) {
        await realEstateService.editOwner({ ...this.perfil, id: this.selected.id })
      } else {
        await realEstateService.createOwner(this.perfil)
      }
      this.loading = false
      notifications.success(`${this.type === 'owner' ? 'Propietario' : 'Asesor'} ${this.selected ? 'editado' : 'creado'} correctamente`)
      this.$store.dispatch('getOwners')
      this.toggleModal()
    },
    toggleModal () {
      this.$emit('clear')
      this.$refs.ownerAdviserForm.reset()
      this.$emit('input', false)
    }
  },
  watch: {
    selected (value) {
      if (!value) return

      console.log(value)

      this.perfil = {
        email: value.email,
        cedula: value.cedula,
        nombres: value.nombres,
        fijo: value.fijo,
        celular: value.celular,
        fechaNacimiento: value.fechaNacimiento,
        nombres2: value.nombres2,
        fijo2: value.fijo2,
        celular2: value.celular2,
        comentarios: value.comentarios
      }
    }
  }
}
</script>
